import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { FaPaperPlane } from "react-icons/fa";
import SectionHeader from "./SectionHeader";
import { viewportOnce } from "../motionPresets";

const Contact = () => {
  const reduced = useReducedMotion();

  return (
    <div
      name="contact"
      className="w-full border-t border-white/[0.06] bg-[#030712] text-white pt-20 pb-24 px-4 sm:px-6 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_45%_at_50%_100%,rgba(99,102,241,0.07),transparent)] pointer-events-none" />

      <div className="max-w-4xl mx-auto relative z-10">
        <SectionHeader
          eyebrow="Contact"
          title="Let's connect"
          subtitle="Questions, collaborations, or opportunities — I will get back to you as soon as I can."
        />

        <motion.div
          className="max-w-lg mx-auto rounded-2xl border border-white/[0.08] bg-slate-900/35 backdrop-blur-sm p-6 md:p-8 ring-1 ring-white/[0.04] shadow-xl shadow-black/30"
          initial={reduced ? false : { opacity: 0, y: 24 }}
          whileInView={reduced ? undefined : { opacity: 1, y: 0 }}
          viewport={viewportOnce}
          transition={{ duration: reduced ? 0 : 0.45, ease: [0.22, 1, 0.36, 1] }}
        >
          <form
            action="https://getform.io/f/27683768-44d3-47ff-80ad-91c69a938be7"
            method="POST"
            className="space-y-4"
          >
            <div>
              <label htmlFor="contact-name" className="sr-only">
                Your name
              </label>
              <input
                id="contact-name"
                type="text"
                name="name"
                placeholder="Your name"
                required
                className="w-full bg-slate-950/60 border border-white/[0.08] rounded-xl p-3.5 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-sky-500/40 focus:border-sky-500/30 text-sm"
              />
            </div>
            <div>
              <label htmlFor="contact-email" className="sr-only">
                Your email
              </label>
              <input
                id="contact-email"
                type="email"
                name="email"
                placeholder="Your email"
                required
                className="w-full bg-slate-950/60 border border-white/[0.08] rounded-xl p-3.5 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-sky-500/40 focus:border-sky-500/30 text-sm"
              />
            </div>
            <div>
              <label htmlFor="contact-message" className="sr-only">
                Your message
              </label>
              <textarea
                id="contact-message"
                name="message"
                placeholder="Your message"
                rows="5"
                required
                className="w-full bg-slate-950/60 border border-white/[0.08] rounded-xl p-3.5 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-sky-500/40 focus:border-sky-500/30 resize-y min-h-[120px] text-sm"
              />
            </div>
            <button
              type="submit"
              className="flex items-center justify-center gap-2 w-full bg-gradient-to-r from-sky-600 to-indigo-600 hover:from-sky-500 hover:to-indigo-500 text-white px-6 py-3.5 rounded-xl text-sm font-semibold transition-all shadow-lg shadow-sky-900/25 ring-1 ring-white/10"
            >
              Send message
              <FaPaperPlane className="text-xs opacity-90" />
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
